import React from "react";

// Lotus illustration used whenever a post has no (working) image.
// Palette matches the "All Yoga Practices" banner: sage petals + gold centre.
const LotusArt = () => (
  <svg viewBox="0 0 400 320" fill="none" aria-hidden="true" focusable="false">
    <ellipse cx="135" cy="205" rx="50" ry="100" transform="rotate(-55 135 205)" fill="#b7c9bb" fillOpacity="0.5" />
    <ellipse cx="265" cy="205" rx="50" ry="100" transform="rotate(55 265 205)"  fill="#c9cfae" fillOpacity="0.5" />
    <ellipse cx="200" cy="125" rx="56" ry="92" fill="#a9c0b1" fillOpacity="0.55" />
    <circle  cx="200" cy="208" r="28" fill="#c4a44a" fillOpacity="0.85" />
  </svg>
);

export default LotusArt;
